import React, { useEffect, useRef, useState } from "react";
import { Group, Path, Rect, Text } from "react-konva";

const dRightArrow = "M24.0173 7.42928C23.9455 7.24534 23.8378 7.07729 23.7005 6.93477L17.666 0.940702C17.5253 0.800982 17.3583 0.690151 17.1745 0.614535C16.9907 0.538919 16.7938 0.5 16.5948 0.5C16.1931 0.5 15.8078 0.658525 15.5237 0.940702C15.2396 1.22288 15.0801 1.60559 15.0801 2.00465C15.0801 2.40371 15.2396 2.78642 15.5237 3.0686L18.9936 6.5002H1.50862C1.10851 6.5002 0.724787 6.65808 0.441866 6.93911C0.158944 7.22014 0 7.60129 0 7.99872C0 8.39615 0.158944 8.77731 0.441866 9.05833C0.724787 9.33936 1.10851 9.49724 1.50862 9.49724H18.9936L15.5237 12.9288C15.3823 13.0682 15.2701 13.2339 15.1935 13.4165C15.1169 13.5991 15.0775 13.795 15.0775 13.9928C15.0775 14.1906 15.1169 14.3865 15.1935 14.5691C15.2701 14.7517 15.3823 14.9174 15.5237 15.0567C15.664 15.1972 15.8308 15.3087 16.0147 15.3848C16.1985 15.4608 16.3957 15.5 16.5948 15.5C16.794 15.5 16.9912 15.4608 17.175 15.3848C17.3589 15.3087 17.5257 15.1972 17.666 15.0567L23.7005 9.06267C23.8378 8.92015 23.9455 8.7521 24.0173 8.56816C24.1682 8.20333 24.1682 7.79412 24.0173 7.42928Z"; // simple triangle/arrow
const dLeftArrow = "M0.113163 8.57072C0.184965 8.75466 0.292629 8.92271 0.429976 9.06523L6.46446 15.0593C6.60513 15.199 6.77212 15.3098 6.9559 15.3855C7.13968 15.4611 7.33666 15.5 7.53559 15.5C7.93733 15.5 8.32263 15.3415 8.60671 15.0593C8.89079 14.7771 9.05038 14.3944 9.05038 13.9954C9.05038 13.5963 8.89079 13.2136 8.60671 12.9314L5.13688 9.4998L22.6218 9.4998C23.0219 9.4998 23.4056 9.34192 23.6886 9.06089C23.9715 8.77986 24.1304 8.39871 24.1304 8.00128C24.1304 7.60385 23.9715 7.22269 23.6886 6.94167C23.4056 6.66064 23.0219 6.50276 22.6218 6.50276L5.13688 6.50276L8.60671 3.07115C8.74811 2.93185 8.86034 2.76611 8.93693 2.5835C9.01352 2.40089 9.05296 2.20503 9.05296 2.00721C9.05296 1.80939 9.01352 1.61352 8.93693 1.43091C8.86034 1.2483 8.74811 1.08257 8.60671 0.943261C8.46646 0.802807 8.29961 0.691323 8.11577 0.615246C7.93193 0.539168 7.73474 0.5 7.53559 0.5C7.33643 0.5 7.13924 0.539168 6.9554 0.615246C6.77156 0.691323 6.60471 0.802807 6.46446 0.943261L0.429976 6.93733C0.292629 7.07985 0.184965 7.2479 0.113163 7.43184C-0.0377254 7.79667 -0.0377254 8.20588 0.113163 8.57072Z"; // simple triangle/arrow

const DoubleArrowIcon = ({ x, y, scale = 1.5, fill = "black" }) => {
    const d = "M9.85501 2.64509L7.85501 0.645093C7.80839 0.598473 7.75304 0.561493 7.69213 0.536263C7.63122 0.511033 7.56594 0.498047 7.50001 0.498047C7.36686 0.498047 7.23916 0.550941 7.14501 0.645093C7.05086 0.739245 6.99796 0.866942 6.99796 1.00009C6.99796 1.13324 7.05086 1.26094 7.14501 1.35509L8.29501 2.50009H2.50001C2.3674 2.50009 2.24022 2.55277 2.14646 2.64654C2.05269 2.74031 2.00001 2.86748 2.00001 3.00009C2.00001 3.1327 2.05269 3.25988 2.14646 3.35365C2.24022 3.44741 2.3674 3.50009 2.50001 3.50009H9.50001C9.59872 3.4996 9.69508 3.4699 9.77694 3.41473C9.8588 3.35957 9.9225 3.2814 9.96001 3.19009C9.9983 3.09904 10.0088 2.99868 9.99007 2.90169C9.97139 2.80469 9.92439 2.7154 9.85501 2.64509ZM7.50001 4.50009H0.500009C0.401296 4.50059 0.304938 4.53029 0.223078 4.58545C0.141218 4.64062 0.0775187 4.71878 0.0400087 4.81009C0.00171898 4.90115 -0.00874236 5.0015 0.0099447 5.0985C0.0286318 5.19549 0.0756299 5.28478 0.145009 5.35509L2.14501 7.35509C2.19149 7.40196 2.24679 7.43915 2.30772 7.46454C2.36865 7.48992 2.434 7.50299 2.50001 7.50299C2.56601 7.50299 2.63137 7.48992 2.6923 7.46454C2.75323 7.43915 2.80853 7.40196 2.85501 7.35509C2.90187 7.30861 2.93907 7.25331 2.96445 7.19238C2.98984 7.13145 3.00291 7.0661 3.00291 7.00009C3.00291 6.93409 2.98984 6.86873 2.96445 6.8078C2.93907 6.74687 2.90187 6.69157 2.85501 6.64509L1.70501 5.50009H7.50001C7.63262 5.50009 7.75979 5.44741 7.85356 5.35365C7.94733 5.25988 8.00001 5.1327 8.00001 5.00009C8.00001 4.86748 7.94733 4.74031 7.85356 4.64654C7.75979 4.55277 7.63262 4.50009 7.50001 4.50009Z"; // simple triangle/arrow
    return (
        <Path
            x={x}
            y={y}
            data={d}
            fill={fill}
            scale={{ x: scale, y: scale }}
        />
    );
};

const FloorPlanButton = ({ shape, draggable = false, shapeRefs, onSelect, onDragEnd, onTransformEnd, onToggle }) => {

    const handleToggle = (shape) => {
        const newDirection = shape.direction === "left" ? "right" : "left";
        if (onToggle) onToggle(shape.id, newDirection);
    };

    const textRef = useRef();
    const arrowRef = useRef();
    const [textWidth, setTextWidth] = useState(0);
    const [arrowWidth, setArrowWidth] = useState(0);

    useEffect(() => {
        setTextWidth(textRef?.current?.getTextWidth?.() || 0);
        setArrowWidth(arrowRef?.current?.getClientRect().width || 0);
    }, [shape.name]);

    const padding = 12;
    const gap = 6;
    const height = 50;

    return (
        <Group
            key={shape.id}
            x={shape.x}
            y={shape.y}
            draggable={draggable}
            onDragEnd={(e) => onDragEnd(e, shape.id)}
            onTransformEnd={(e) => onTransformEnd(e, shape.id)}
            ref={(node) => {
                if (shapeRefs?.current) {
                    shapeRefs.current[shape.id] = node;
                }
            }}
        >
            <Rect
                onClick={(e) => onSelect(e, shape.id)}
                width={textWidth + arrowWidth + padding * 2 + gap}
                height={height}
                cornerRadius={25}
                stroke="white"
                fill="rgba(102, 102, 102, 0.2)"
            />
            {shape.direction === 'left' ? (
                <Group x={padding} y={16} onClick={(e) => onSelect(e, shape.id)}>
                    <Path
                        ref={arrowRef}
                        data={dLeftArrow}
                        fill={"white"}
                    />
                    <Text
                        ref={textRef}
                        x={arrowWidth + gap}
                        y={1}
                        text={shape.name}
                        fill="white"
                        fontSize={16}
                        fontStyle="bold"
                    />
                </Group>
            ) : (
                <Group x={padding} y={16} onClick={(e) => onSelect(e, shape.id)}>
                    <Text
                        y={1}
                        ref={textRef}
                        text={shape.name}
                        fill="white"
                        fontSize={16}
                        fontStyle="bold"
                    />
                    <Path
                        ref={arrowRef}
                        x={textWidth + gap}
                        data={dRightArrow}
                        fill={"white"}
                    />
                </Group>
            )}
            <Group x={(textWidth + arrowWidth + padding * 2 + gap) / 2 - 15} y={-20} onClick={() => handleToggle(shape)}>
                <Rect
                    width={30}
                    height={15}
                    cornerRadius={24}
                    fill="white"
                    stroke="white"
                />
                <DoubleArrowIcon x={7} y={1} />
            </Group>
        </Group>
    );
};

export default FloorPlanButton;
